import styled from "styled-components";

export const Wrapper = styled("div")(({ theme }) => ({
  display: "block",
  width: "100%",
}));
export const HeaderWrapper = styled('div')(({theme}) => ({
  padding: '24px 0',

  [theme.down("sm")]: {
    padding: '15px 0',
  },
}));

export const Header = styled('div')(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  padding: '16px 24px',
  background: theme.palette.gray[50],
  borderTop: `1px solid ${theme.palette.border.light}`,
  borderBottom: `1px solid ${theme.palette.border.light}`,
  margin: '0 -20px 20px',

  [theme.down("sm")]: {
    padding: '12px 15px',
    margin: '0 -15px 15px',
  },
}));

export const Title = styled("div")(({ theme }) => ({
  width: 120,
  fontSize: 14,
  color: theme.palette.text.primary,
  letterSpacing: "1.5px",
  paddingLeft: 5,

  [theme.down("sm")]: {
    width: "100%",
    fontSize: 13,
    letterSpacing: "1px",
  },
}));

export const FormWrapper = styled("div")(({ theme, $isShowMiddleName }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(6, minmax(0, 1fr))", // Use 6 columns for flexibility
  gap: 16,
  flexGrow: 1,
  width: "100%",
  gridTemplateAreas: $isShowMiddleName 
    ? `'citizenship citizenship gender gender birthDate birthDate' 
       'lastName lastName firstName firstName middleName middleName' 
       'document document documentNumber documentNumber validThrough validThrough'`
    : `'citizenship citizenship gender gender birthDate birthDate' 
       'lastName lastName lastName firstName firstName firstName' 
       'document document documentNumber documentNumber validThrough validThrough'`,

  [theme.down("sm")]: {
    display: "flex",
    flexDirection: "column",
    gap: 12,
    padding: "0",
  },
}));

export const InputBlock = styled("div")(({ theme, removeOnMobile }) => ({
  "&.citizenship": {
    gridArea: 'citizenship'
  },
  "&.gender": {
    gridArea: 'gender'
  },
  "&.birthDate": {
    gridArea: 'birthDate'
  },
  "&.lastName": {
    gridArea: 'lastName'
  },
  "&.firstName": {
    gridArea: 'firstName'
  },
  "&.middleName": {
    gridArea: 'middleName',
  },
  "&.document": {
    gridArea: 'document'
  },
  "&.documentNumber": {
    gridArea: 'documentNumber'
  },
  "&.validThrough": {
    gridArea: 'validThrough'
  },
  [theme.down("sm")]: {
    gridArea: "auto !important",
    display: removeOnMobile ? "none" : "block",
  },
}));
